import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function isPresent<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
